import logo from './logo.svg';
import './App.css';

import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Routes
} from "react-router-dom";

import Home from './components/Home';
import Layout from './components/Layout';
import Career from './components/Career';
import Contact from './components/Contact';
import Solution from './components/Solution';
import News from './components/News';

function App() {
  return (
   
  <Routes>
        <Route path="/" element={<Layout />} >
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Solution />} />
        <Route path="/career" element={<Career />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/news" element={<News />} />
        </Route>
  </Routes>


  );
}

export default App;
